/**
 * Created by vsliwka on 03/08/2017.
 */
export class ContentTypeModel {
  public id: number = null;
  public label: string;
  public category: string;
  public code: string;
  public codeBaseFileName: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
